import { Button } from '@/components/ui/Button';
import { safeWebHref } from '@/lib/utils/claim.utils';
import type { PartnerContact } from '../api/trusted-partners.api';
import { useEmailClick, useSchedulingClick } from '../hooks/useTrustedPartners';

import { TRUSTED_PARTNERS_STRINGS as S } from '../trusted-partners.constants';

interface ContactActionProps {
  entityId: string;
  contact: PartnerContact;
}

/**
 * The partner's one chosen contact method on the profile page (FR-109): a
 * `mailto:` link that opens the member's mail app, or a Scheduling link that opens
 * in a new tab. Both are real anchors, so the browser performs the navigation
 * itself; the scheduling and email clicks are logged afterwards (FR-110, FR-118) and a
 * failed log is reported by the hook without affecting the navigation.
 */
export function ContactAction({ entityId, contact }: ContactActionProps) {
  const countScheduling = useSchedulingClick();
  const countEmail = useEmailClick();

  if (contact.type === 'email') {
    return (
      <Button asChild variant="green" className="px-6! py-2.5! text-sm">
        <a href={`mailto:${contact.address}`} onClick={() => countEmail.mutate(entityId)}>
          {S.CONTACT}
        </a>
      </Button>
    );
  }

  const href = safeWebHref(contact.url);
  if (!href) return null;
  return (
    <Button asChild variant="green" className="px-6! py-2.5! text-sm">
      <a href={href} target="_blank" rel="noopener noreferrer" onClick={() => countScheduling.mutate(entityId)}>
        {S.SCHEDULE}
      </a>
    </Button>
  );
}
